import React, { useEffect } from "react";
import { faqs } from "../sections/FAQ";
type SiteMetaProps = {
  title: string;
  description: string;
  path?: string;
  includeFaq?: boolean;
};
const canonicalOrigin = "https://www.perthflatpackcabinets.com.au"; // TODO: confirm live domain before launch

function SiteMeta({
  title,
  description,
  path = "/",
  includeFaq = false
}: SiteMetaProps) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", `${canonicalOrigin}${path}`, "property");
    setCanonical(`${canonicalOrigin}${path}`);
    const scripts: Array<Record<string, unknown>> = [{
      "@context": "https://schema.org",
      "@graph": [{
        "@type": "Organization",
        "@id": `${canonicalOrigin}/#organization`,
        name: "Perth Flat Pack Cabinets",
        url: canonicalOrigin,
        email: "austen@lifestylecabinets.com.au"
      }, {
        "@type": "WebSite",
        "@id": `${canonicalOrigin}/#website`,
        url: canonicalOrigin,
        name: "Perth Flat Pack Cabinets",
        publisher: {
          "@id": `${canonicalOrigin}/#organization`
        }
      }, {
        "@type": "Service",
        name: "Online custom flat pack cabinetry ordering",
        provider: {
          "@id": `${canonicalOrigin}/#organization`
        },
        description: "Online job creation, configuration and ordering for custom flat pack cabinetry in Perth, Western Australia."
      }, {
        "@type": "Person",
        name: "Austen Mitchell Thompson",
        jobTitle: "Director",
        email: "austen@lifestylecabinets.com.au",
        worksFor: {
          "@id": `${canonicalOrigin}/#organization`
        }
      }]
    }];
    if (includeFaq) {
      scripts.push({
        "@context": "https://schema.org",
        "@graph": [{
          "@type": "FAQPage",
          mainEntity: faqs.map(([question, answer]) => ({
            "@type": "Question",
            name: question,
            acceptedAnswer: {
              "@type": "Answer",
              text: answer
            }
          }))
        }]
      });
    }
    const element = document.createElement("script");
    element.type = "application/ld+json";
    element.id = "pfpc-structured-data";
    element.text = JSON.stringify(scripts.length === 1 ? scripts[0] : scripts);
    document.getElementById(element.id)?.remove();
    document.head.appendChild(element);
    return () => element.remove();
  }, [description, includeFaq, path, title]);
  return null;
}
function setMeta(key: string, content: string, attribute: "name" | "property" = "name") {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}
function setCanonical(href: string) {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.appendChild(element);
  }
  element.href = href;
}
export { SiteMeta };